import React, { useEffect } from "react";
import "../styles/contentcontainer/Content.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Content(props) {
  /*
   * tabs: bool
   * tabList: list/obj -- [{label: string, id:numb  }]
   * title: string
   * children
   */
  const [value, setValue] = React.useState(props.lastTab);
  const [tabpanel, setTabpanel] = React.useState(null);

  useEffect(() => {
    if (props.tabs) {
      var tab = props.children.find((item) => item.props.value === value);

      setTabpanel(tab);
    }
  }, [props.tabs, props.children, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("lastTab", JSON.stringify(newValue));
  };

  return (
    <div className="content-container">
      <div>
        {props.title ? (
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontWeight: 700, color: "#1a1d23", fontSize: "1.75rem", mb: 0.5 }}
          >
            {props.title}
          </Typography>
        ) : null}
        {props.subtitle ? (
          <Typography
            variant="h5"
            component="h2"
            sx={{ color: "#5f6877", fontWeight: 400, fontSize: "0.95rem" }}
          >
            {props.subtitle}
          </Typography>
        ) : null}
      </div>

      <div className="content-container--body">
        {props.tabs ? (
          <div className="tabs-container">
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                {props.tabList.map((tab, index) => {
                  return (
                    <Tab key={index} value={tab.id} label={tab.label} wrapped />
                  );
                })}
              </Tabs>
            </Box>
          </div>
        ) : null}
        <div className="content-area">
          {props.tabs ? tabpanel : props.children}
        </div>
      </div>
    </div>
  );
}
